import React, { useEffect, useState, useContext } from "react";
import Input from "../../material/input/Input";
import Select from "../../material/select/Select";
import { HashLoader } from "react-spinners";
import * as publicApi from "../../../service/publicApi";
import * as userApi from "../../../service/userApi";
import moment from "moment/moment";
import "moment/locale/th";
import PageHeader from "../../pageheader/PageHeader";
import MenuProvideradmin from "../navProvideradmin/MenuProvideradmin";
import { CurrentUserContext } from "../../../App";
import * as regex from "../../../service/regex";
import Datepicker from "../../material/datepicker/Datepicker";
// import Breadcrumb from "../../breadcrumb/breadcrumb";
import Breadcrumb from "../../public/breacrumb/breadcrumb";

import styles from "../styleProvider.module.css";
import MenuLegged from "../../header/Menu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Footer from "../../footer/Footer";

function ManageInfoExecutive() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [loading, setLoading] = useState(true);
  const [getImgDefault, setGetImgDefault] = useState(null);
  const [showImageList, setShowImageList] = useState([]);
  const [pname, setPname] = useState("");
  const [pid, setPid] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [address, setAddress] = useState("");
  const [postCode, setPostCode] = useState("");
  const [birthday, setBirthday] = useState("");
  const [gender, setGender] = useState("");

  const [provinceId, setProvinceId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [subDistrictId, setSubDistrictId] = useState("");

  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);

  const [moo, setMoo] = useState("");
  const [road, setRoad] = useState(null);
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [policyPersonalInformation, setPolicyPersonalInformation] =
    useState(false); //policy_personal_information
  const [consentForm, setConsentForm] = useState(false); //consent_form;
  const [error, setError] = useState(false);

  let genderList = [
    {
      key: "male",
      value: "ชาย",
    },
    {
      key: "female",
      value: "หญิง",
    },
  ];
  let pnameList = [
    {
      key: "นาย",
      value: "นาย",
    },
    {
      key: "นาง",
      value: "นาง",
    },
    {
      key: "นางสาว",
      value: "นางสาว",
    },
  ];

  useEffect(() => {
    getDataUser();
  }, []);

  useEffect(() => {
    getProvinceList();
  }, [provinceId]);

  const getDataUser = async () => {
    setLoading(true);
    let res = await userApi.data();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setPname(res["data"]["user_data"]["pname"]);
        setFname(res["data"]["user_data"]["fname"]);
        setLname(res["data"]["user_data"]["lname"]);
        setPid(res["data"]["user_data"]["pid"]);
        setBirthday(res["data"]["user_data"]["birthday"]);
        // // setBirthday(res['data']['user_data']['birthday'])
        //setBirthday(moment(res['data']['user_data']['birthday']).add(543, 'years').format('DD MMMM YYYY'))
        setAddress(res["data"]["user_data"]["current_address"]["address"]);
        setRoad(res["data"]["user_data"]["current_address"]["road"]);
        setMoo(res["data"]["user_data"]["current_address"]["village_number"]);
        setPostCode(res["data"]["user_data"]["current_address"]["post_code"]);
        setProvinceId(
          res["data"]["user_data"]["current_address"]["province_id"],
        );
        setGender(res["data"]["user_data"]["gender"]);
        getDistrictList(
          res["data"]["user_data"]["current_address"]["province_id"],
        );
        setDistrictId(
          res["data"]["user_data"]["current_address"]["district_id"],
        );
        getSubDistrictList(
          res["data"]["user_data"]["current_address"]["district_id"],
        );
        setSubDistrictId(
          res["data"]["user_data"]["current_address"]["sub_district_id"],
        );
        setEmail(res["data"]["user_data"]["email"]);
        setPhoneNumber(res["data"]["user_data"]["phone_number"]);
        setPolicyPersonalInformation(
          res["data"]["user_data"]["permission"]["policy_personal_information"],
        );
        setConsentForm(res["data"]["user_data"]["permission"]["consent_form"]);

        localStorage.setItem("user", JSON.stringify(res["data"]["user_data"]));

        const currentOrigin = window.location.origin;
        const getBaseUrl = currentOrigin.includes('dmsc.moph.go.th') 
          ? currentOrigin 
          : 'https://dmsc-static.devfunction.com';
        const imageSrc = res["data"]["user_data"]?.["profile_image"] 
          && `${getBaseUrl}/image/${res["data"]["user_data"]?.["profile_image"]}`;
        setGetImgDefault(`${imageSrc}`);

        //localStorage.setItem('user', JSON.stringify(res['data']['user_data']))
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateProfileData = async (
    phone_number,
    email,
    current_address,
    permission,
  ) => {
    let res = "";
    setLoading(true);
    res = await userApi.updateProfileData(
      phone_number,
      email,
      current_address,
      permission,
    );
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const updateProfileImage = async (targetfiles) => {
    let formData = new FormData();
    formData.append("image", targetfiles[0]);
    let res = "";
    setLoading(true);
    res = await userApi.updateProfileImage(formData);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        getDataUser();
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getProvinceList = async () => {
    setLoading(true);
    let res = await publicApi.getProvinceList();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setProvinceList(
          res["data"]["province_list"].map((item) => {
            return {
              key: item["province_id"],
              value: item["province_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDistrictList(
          res["data"]["district_list"].map((item) => {
            return {
              key: item["district_id"],
              value: item["district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getSubDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getSubDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setSubDistrictList(
          res["data"]["sub_district_list"].map((item) => {
            return {
              key: item["sub_district_id"],
              value: item["sub_district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onSelectFile = (e) => {
    if (e !== "") {
      // console.log(e.target.files);
      const uploadFiles = e.target.files;
      createUrlBlobFile(uploadFiles);
      updateProfileImage(uploadFiles);
    }
  };

  const createUrlBlobFile = (uploadFiles) => {
    const uploadFilesImageList = Array.from(uploadFiles);

    const imageData = uploadFilesImageList.map((file) => {
      return {
        name: file["name"],
        url: URL.createObjectURL(file),
      };
    });
    setShowImageList(imageData);
  };

  const submitButtonClick = () => {
    if (!pname) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกคำนำหน้า" });
      return;
    }
    if (!address) {
      setIsMessage({ type: "warning", data: "กรุณากรอกที่อยู่" });
      return;
    }
    if (!moo) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหมู่" });
      return;
    }
    if (!postCode) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรหัสไปรษณีย์" });
      return;
    }
    if (!provinceId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกจังหวัด" });
      return;
    }
    if (!districtId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกอำเภอ" });
      return;
    }
    if (!subDistrictId) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกตำบล" });
      return;
    }
    if (!phoneNumber) {
      setIsMessage({ type: "warning", data: "กรุณากรอกเบอร์โทร" });
      return;
    }
    if (!email) {
      setIsMessage({ type: "warning", data: "กรุณากรอก Email" });
      return;
    } else {
      let current_address = {
        address: address,
        village_number: moo,
        alley: "-",
        road: road ?? "-",
        sub_district_id: subDistrictId,
        district_id: districtId,
        province_id: provinceId,
        post_code: postCode,
      };
      let permission = {
        policy_personal_information: policyPersonalInformation,
        consent_form: consentForm,
      };
      updateProfileData(phoneNumber, email, current_address, permission);
    }
  };
  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "สำหรับผู้บริหาร", url: "" },
  ];
  const handleChangeValue = (e, value, setValue) => {
    if (value === true) {
      setValue(false);
    } else {
      setValue(true);
    }
  };

  const handleError = () => {
    setError(true);
  };
  return (
    <>
      <div className={styles.page}>
        <div className="mt-[10px]">
          <Breadcrumb pathItems={pathItems} />
        </div>
        <div className={styles.container}>
          <div className="flex flex-col gap-2 items-center w-full pb-5 mt-[50px]">
            <h1 className="lg:text-2xl flex text-3xl font-bold">
              จัดการข้อมูลส่วนตัว
            </h1>
            <span className="lg:text-lg flex text-xl font-bold">
              กรุณากรอกข้อมูลให้ครบถ้วน
            </span>
            <span className="lg:text-base flex text-lg font-bold">
              เพิ่มข้อมูลที่อยู่และตั้งค่าบัญชีเพื่อเข้าใช้งานในครั้งถัดไป
            </span>
          </div>

          <div className="lg:flex-col lg:items-center flex flex-row gap-6 w-full">
            <div className="2sm:w-full flex flex-col gap-2 items-center w-[20%] max-h-[380px] text-nowrap">
              <div
                className={`overflow-hidden aspect-square ${styles.previewProfile}`}
              >
                {showImageList.length > 0 ? (
                  <>
                    {showImageList.map((i, idx) => {
                      return <img key={idx} src={i["url"]} alt="" />;
                    })}
                  </>
                ) : (
                  <>
                    {getImgDefault ? (
                      <>
                        <img
                          src={
                            error
                              ? require("../../../asset/image/image-user.svg")
                                  .default
                              : getImgDefault
                          }
                          alt=""
                          onError={handleError}
                        />
                      </>
                    ) : (
                      <img
                        className="aspect-square object-cover"
                        src={
                          require("../../../asset/image/image-user.svg").default
                        }
                        alt=""
                      />
                    )}
                  </>
                )}
              </div>
              <label className="lg:text-xs max-w-[200px] flex flex-row justify-center items-center gap-2 px-16 py-2 rounded-md text-white text-base bg-[#4F9C9D] cursor-pointer">
                <FontAwesomeIcon icon={faArrowDown} />
                <span>อัปโหลดไฟล์</span>
                <input
                  type="file"
                  accept="image/png ,image/jpeg"
                  name="images"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    onSelectFile(e);
                  }}
                />
              </label>
              <div className="lg:text-xs flex flex-col gap-1 justify-center items-center w-full text-base">
                <span>อัปโหลดไฟล์</span>
                <span>สกุล jpg, png</span>
                <span>ขนาดไฟล์ไม่เกิน 10 MB</span>
              </div>
            </div>

            <div className="2sm:w-full flex flex-col gap-4 w-[70%] h-full">
              <div className="flex flex-col gap-1 py-2 w-full">
                <span className="lg:text-lg text-xl font-bold">
                  ข้อมูลส่วนตัว
                </span>
                <div className="sm:flex-col flex flex-row gap-5 justify-between w-full pb-2">
                  <div className="sm:w-full w-1/2">
                    <Select
                      label="เลือกคำนำหน้า"
                      disabled
                      value={pname}
                      setValue={setPname}
                      list={pnameList}
                      placeholder="เลือกคำนำหน้า"
                    ></Select>
                  </div>
                </div>

                <div className="sm:flex-col flex flex-row gap-5 justify-between w-full pb-2">
                  <div className="sm:w-full w-1/2">
                    <Input
                      label="ชื่อ"
                      disabled
                      value={fname}
                      setValue={setFname}
                      placeholder="ชื่อ"
                    ></Input>
                  </div>
                  <div className="sm:w-full w-1/2">
                    <Input
                      label="นามสกุล"
                      disabled
                      value={lname}
                      setValue={setLname}
                      placeholder="นามสกุล"
                    ></Input>
                  </div>
                </div>

                <div className="sm:flex-col flex flex-row gap-5 justify-between w-full pb-2">
                  <div className="sm:w-full w-1/2">
                    <Input
                      label="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)"
                      regex={regex.pid()}
                      disabled
                      placeholder="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)"
                      value={pid}
                      setValue={setPid}
                    ></Input>
                  </div>
                  <div className="sm:w-full w-1/2">
                    <Select
                      label="เพศ"
                      placeholder="เพศ"
                      value={gender}
                      setValue={setGender}
                      disabled
                      list={genderList}
                    ></Select>
                  </div>
                </div>

                <div className="sm:flex-col flex flex-row gap-5 justify-between w-full pb-2">
                  <div className="sm:w-full w-1/2 pr-[20px]">
                    {/* <Datepicker
                      disabled
                      label="วันเกิด"
                      value={birthday}
                      setValue={setBirthday}
                    ></Datepicker> */}
                    <Input
                      regex={regex.pid()}
                      label="วันเกิด"
                      disabled
                      placeholder="วันเกิด"
                      value={birthday}
                    ></Input>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-2 py-2 w-full">
                <span className="lg:text-lg text-xl font-bold">
                  ที่อยู่ปัจจุบัน
                </span>

                <div className="flex flex-row gap-5 justify-between w-full pb-2">
                  <div className="sm:w-full w-1/2">
                    <Input
                      label="บ้านเลขที่"
                      placeholder="บ้านเลขที่"
                      value={address}
                      setValue={setAddress}
                    ></Input>
                  </div>
                  <div className="sm:w-full w-1/2">
                    <Input
                      label="ถนน"
                      placeholder="ถนน"
                      value={road}
                      setValue={setRoad}
                    ></Input>
                  </div>
                </div>
                <div className="flex flex-row gap-5 justify-between w-full pb-2">
                  <div className="sm:w-full w-1/2">
                    <Input
                      label="หมู่"
                      placeholder="หมู่"
                      value={moo}
                      setValue={setMoo}
                    ></Input>
                  </div>

                  <div className="sm:w-full w-1/2">
                    <Select
                      label="จังหวัด"
                      placeholder="จังหวัด"
                      value={provinceId}
                      setValue={(e) => {
                        setProvinceId(e);
                        setDistrictId("");
                        setDistrictList([]);
                        setSubDistrictId("");
                        setSubDistrictList([]);
                        getDistrictList(e);
                      }}
                      list={provinceList}
                    ></Select>
                  </div>
                </div>
                <div className="flex flex-row gap-5 justify-between w-full pb-2">
                  <div className="sm:w-full w-1/2">
                    <Select
                      label="อำเภอ"
                      placeholder="อำเภอ"
                      value={districtId}
                      setValue={(e) => {
                        setDistrictId(e);
                        setSubDistrictId("");
                        setSubDistrictList([]);
                        getSubDistrictList(e);
                      }}
                      list={districtList}
                    ></Select>
                  </div>
                  <div className="sm:w-full w-1/2">
                    <Select
                      label="ตำบล"
                      placeholder="ตำบล"
                      value={subDistrictId}
                      setValue={setSubDistrictId}
                      list={subDistrictList}
                    ></Select>
                  </div>
                </div>
                <div className="flex flex-row gap-5 justify-between w-full pb-2">
                  <div className="sm:w-full w-1/2 pr-[20px]">
                    <Input
                      label="รหัสไปรษณีย์"
                      placeholder="รหัสไปรษณีย์"
                      value={postCode}
                      setValue={setPostCode}
                    ></Input>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-1 py-2 w-full">
                <span className="lg:text-lg text-xl font-bold">
                  ข้อมูลติดต่อ
                </span>
                <div className="flex flex-row gap-5 justify-between w-full pb-2">
                  <div className="sm:w-full w-1/2">
                    <Input
                      label="หมายเลขโทรศัพท์"
                      placeholder="หมายเลขโทรศัพท์"
                      value={phoneNumber}
                      setValue={setPhoneNumber}
                    ></Input>
                  </div>
                  <div className="sm:w-full w-1/2">
                    <Input
                      label="อีเมล"
                      placeholder="อีเมล"
                      value={email}
                      setValue={setEmail}
                    ></Input>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-1 py-2 w-full">
                <div>
                  <span className="lg:text-lg text-xl font-bold">
                    ยินยอมอนุญาตการเปิดเผยและเข้าถึงข้อมูล
                  </span>
                  <div className={styles.alignTx}>
                    <div className={styles.checkboxContainer}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={policyPersonalInformation}
                            onChange={(e) =>
                              handleChangeValue(
                                e,
                                policyPersonalInformation,
                                setPolicyPersonalInformation,
                              )
                            }
                            //onChange={setPolicyPersonalInformation}
                            size="medium"
                            sx={{
                              "&.Mui-checked": {
                                color: "#1eae22",
                              },
                            }}
                          />
                        }
                        label={
                          <span>
                            การยินยอมให้แลกเปลี่ยนข้อมูลกับระเบียบสุขภาพส่วนบุคคลที่เชื่อมต่อกับระบบ
                            "ผูกพันธุ์"
                          </span>
                        }
                      />
                      {/* <input id="analyst" checked={analystCheck} onChange={(e) => { setAnalystCheck(e.target.checked) }} type="checkbox"/>
                                <label for="analyst" className={styles.tx}>การยินยอมให้แลกเปลี่ยนข้อมูลกับระเบียบสุขภาพส่วนบุคคลที่เชื่อมต่อกับระบบ "ผูกพันธุ์"</label> */}
                    </div>
                    <div className={styles.checkboxContainer}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={consentForm}
                            onChange={(e) =>
                              handleChangeValue(e, consentForm, setConsentForm)
                            }
                            //onChange={setConsentForm}
                            size="medium"
                            sx={{
                              "&.Mui-checked": {
                                color: "#1eae22",
                              },
                            }}
                          />
                        }
                        label={
                          <span>
                            ยิมยอมในการให้ข้อมูลรตรวจงพันธุกรรมที่มาจากระบบสารสนเทศของโรงพยาบาล
                            การตรวจจากห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์
                            และระบบอื่นๆสามารถใช้แลกเปลี่ยนและจัดเก็บในระบบผูกพันธุ์ได้
                          </span>
                        }
                      />
                      {/* <input id="approver" checked={approverCheck} onChange={(e) => { setApproverCheck(e.target.checked) }} type="checkbox"/>
                                <label for="approver" className={styles.tx}>ยิมยอมในการให้ข้อมูลรตรวจงพันธุกรรมที่มาจากระบบสารสนเทศของโรงพยาบาล <br/> การตรวจจากห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์ และระบบอื่นๆสามารถใช้แลกเปลี่ยนและจัดเก็บในระบบผูกพันธุ์ได้</label> */}
                    </div>
                  </div>
                </div>

                <button
                  onClick={submitButtonClick}
                  className="h-12 w-64 rounded bg-[#42a1ef] text-[#ffffff] hover:ring-2 ring-[#B9DFC5] active:scale-90 transition-all duration-100 ease-in-out shadow-md mx-auto mt-[30px] mb-[30px]"
                >
                  <p>บันทึกการแก้ไข</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageInfoExecutive;
